var isObject = require('../internals/is-object');

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/internals/a-possible-prototype.js
// module id = Y4Rk
// module chunks = 0